import React, { FC } from 'react'
import Svg, { Path } from 'react-native-svg'

const FluentArrowLeft: FC<{ fillColor?: string }> = ({
  fillColor = '#212121',
  ...props
}) => {
  return (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <Path
        d='M10.733 19.79a.75.75 0 001.034-1.086L5.516 12.75H20.25a.75.75 0 000-1.5H5.516l6.251-5.955a.75.75 0 00-1.034-1.086l-7.42 7.067a.995.995 0 00-.3.58.754.754 0 00.001.289.995.995 0 00.3.579l7.419 7.067z'
        fill={fillColor}
      />
    </Svg>
  )
}

export default FluentArrowLeft
